import { render, staticRenderFns } from "./formNotePatient.vue?vue&type=template&id=51e93f9b&"
import script from "./formNotePatient.vue?vue&type=script&lang=js&"
export * from "./formNotePatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports